import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectClientValue } from "../../../State/Slices/SelectedClientSlice";
import { MenuCategory } from "../../../Enums/MenuCategory";

const useStyles = makeStyles({
  linkText: {
    color: "black",
    textDecoration: "none",
  },
  item: {
    margin: "20px 0px 0px 0px",
    justifyContent: "flex-start",
    display: "flex",
    width: "220px",
  },
  disabledItem: {
    margin: "20px 0px 0px 0px",
    justifyContent: "flex-start",
    display: "flex",
    width: "220px",
    pointerEvents: "none",
    opacity: "0.5",
  },
  itemText: {
    paddingRight: "20px",
  },
  itemIcon: {
    paddingRight: "15px",
    minWidth: "20px",
    lineHeight: "10px",
  },
});

function checkMenuIndex(navMenuSelection, menuCategory) {
  if (navMenuSelection === menuCategory) {
    return true;
  }
  return false;
}

export default function SubMenuItem(props) {
  const classes = useStyles();
  const selectedClient = useSelector(selectClientValue);

  const [visibleInMenu, setVisibleInMenu] = useState(false);

  const currentRoute = useLocation().pathname;

  useEffect(() => {
    setVisibleInMenu(
      checkMenuIndex(props.navMenuSelection, props.menuCategory)
    );
  }, [props.navMenuSelection, props.menuCategory, selectedClient]);

  if (visibleInMenu === true) {
    if (props.menuCategory === MenuCategory.MoreApps) {
      return (
        <NavLink
          className={classes.linkText}
          to={{ pathname: props.route }}
          target="_blank"
        >
          <MenuItem
            onClick={props.clickEvent}
            className={classes.item}
            selected={currentRoute === props.route}
          >
            <ListItemIcon className={classes.itemIcon}>
              {props.icon}
            </ListItemIcon>
            <ListItemText className={classes.itemText}>
              {props.title}
            </ListItemText>
          </MenuItem>
        </NavLink>
      );
    } else {
      return (
        <NavLink className={classes.linkText} to={props.route}>
          <MenuItem
            onClick={props.clickEvent}
            className={classes.item}
            selected={currentRoute === props.route}
          >
            <ListItemIcon className={classes.itemIcon}>
              {props.icon}
            </ListItemIcon>
            <ListItemText className={classes.itemText}>
              {props.title}
            </ListItemText>
          </MenuItem>
        </NavLink>
      );
    }
  } else {
    return null;
  }
}
